// /careers — layout route (RU). Pass-through <Outlet /> so /careers/$sphere
// mounts as a child. Hub lives in careers.index.tsx. Same convention as
// redeem.tsx / redeem.index.tsx / redeem.$code.tsx.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/careers")({
  component: () => <Outlet />,
});
